import { useEffect, useState } from 'react'

import { useAppDispatch } from '@App/hooks'

import { setConfig } from '@Redux/slices/config/ConfigSlice'
import { checkAsync } from '@Redux/slices/user/UserSlice'

import { HeaderNavigation } from '@UI/crypto_exchange/desktop/components/common/Header/HeaderNavigation'
import { Notifications } from '@UI/crypto_exchange/desktop/components/common/Notifications'

import classes from './App.module.scss'
import { Header } from './components/common/Header'
import { Loader } from './components/common/Loader'
import Portal from './components/common/Notifications/container'
import ModalContainer from './components/modals/ModalContainer/ModalContainer'
import { RouterContainer } from './routes/RouterContainer'
import { subscribeToPublicService } from '@Redux/slices/sockets/PublicServiceConnectionSlice'
import { Events } from '@App/sockets/types'

export function App() {
  const [loading, setLoading] = useState(true)

  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setConfig())
      .then(() => {
        dispatch(checkAsync())
        dispatch(subscribeToPublicService({ event: Events.GetMarkets }))
      })
      .finally(() => setLoading(false))
  }, [])

  if (loading) {
    return <Loader />
  }

  return (
    <>
      <div className={classes.pageWrapper}>
        <Header />
        <div className={classes.mainWrapper}>
          <HeaderNavigation />
          <div className={classes.main}>
            <RouterContainer />
          </div>
        </div>
      </div>
      <Portal>
        <Notifications delay={5000} />
      </Portal>
      <ModalContainer />
    </>
  )
}
